import Header from "../../components/Header";
import FooterItem from "../../components/FooterItem";
import React from 'react';
import { useParams } from "react-router-dom";
import { getArticleById, getUserInfoByName } from "../../api/mockData";
import {Flex, Card, Avatar} from 'antd';
import MarkdownRender from "../../components/MarkdownRender"; // 导入核心组件
import MarkdownNav from "../../components/MarkdownNav"; // 导入导航组件
import "./style.css";


const PostDetail = () => {
  const {id} = useParams();
  // 将字符串类型的id转换为数字类型
  const articleId = parseInt(id, 10);
  const article = getArticleById(articleId);
  const content = article?.content|| "# 未找到文章\n ## 暂无内容";
  const createTime = article?.createTime || "";
  const author = article?.author || "未知作者";
  const avatarSrc = getUserInfoByName(author)?.avatar || "";
  const title = article?.title || "未命名文章";

  return (
    <div className="post-detail-container">
      <Header index={-1} />
      {/* 水平方向的布局 */}
      <Flex  justify="flex-start" gap={20} className = "post-detail-maincontainer">
        {/* 左侧导航栏 */}
        <Flex vertical className = "post-detail-sider">
          {/* 显示作者信息的卡片 */}
          <Flex className = "post-detail-card" vertical justify="flex-start" align="center"> 
            <Avatar src={avatarSrc} size={96} />
            <h2>{author}</h2>
            <hr></hr>
            <h1>{title}</h1>

            <p style = {{color:'gray'}}>创建时间：{createTime}</p>
          </Flex>
          <MarkdownNav content={content} className = "post-detail-markdown-nav"/>
        </Flex>
        {/* 右侧的MarkdownRender */}
        <MarkdownRender text={content} className = "post-detail-markdown"/>
        
      </Flex>
      <FooterItem />
    </div>
  );
}
export default PostDetail;